const isAdmin = (user) => user.admin === true;
const isAdminOr = f => (company, user) => isAdmin(user) || f(company, user);
const isAtLeastAdminMember = (company, user) => ['owner', 'admin'].includes(company.users?.[user.id]?.role);

exports.canUpdateMember = isAdminOr(isAtLeastAdminMember);
exports.canUpdateCompany = isAdminOr(isAtLeastAdminMember);
